import type { CompanyProfile } from "@/types";

/**
 * Perfil de empresa por defecto (mock).
 * Cuando el BFF esté disponible se reemplaza por datos reales.
 */
export const mockCompanyProfile: CompanyProfile = {
  id: "company-1",
  datos: {
    razonSocial: "Constructora Andes SpA",
    rut: "76.123.456-7",
    rubros: ["Tecnología y Software", "Servicios Profesionales", "Consultoría"],
    servicios: ["Desarrollo a medida", "Integración de sistemas", "Soporte TI", "Cloud & DevOps"],
    productos: ["Plataforma de gestión documental"],
    especialidades: ["Sector público", "Salud", "Educación"],
    categorias: ["Tecnología y Software", "Consultoría", "Servicios Profesionales"],
    keywords: [
      "software",
      "soporte ti",
      "consultoría",
      "transformación digital",
      "gestión documental",
    ],
    regiones: ["Metropolitana", "Valparaíso", "Biobío"],
    tamano: "mediana",
    aniosExperiencia: 12,
  },
  capacidades: {
    certificaciones: ["ISO 27001", "ISO 9001", "PCI DSS"],
    tecnologias: ["AWS", "Azure", "Kubernetes", "PostgreSQL"],
    frameworks: ["React", "NestJS", ".NET", "Java Spring"],
    herramientas: ["Jira", "GitLab", "Datadog"],
    infraestructura: ["Cloud", "On-premise híbrido"],
    personalTecnico: 48,
    maquinaria: [],
    experienciaSectorial: ["Hospitales", "Municipalidades", "Universidades"],
  },
  estrategia: {
    presupuestoMin: 20_000_000,
    presupuestoMax: 800_000_000,
    presupuestoMoneda: "CLP",
    regionesPreferidas: ["Metropolitana", "Valparaíso"],
    sectoresPreferidos: ["Tecnología y Software", "Consultoría"],
    complejidadAceptada: "alta",
    toleranciaRiesgo: "media",
    modalidadesPreferidas: ["Licitación Pública", "Convenio Marco"],
  },
  historial: {
    ganadas: 34,
    perdidas: 62,
    postuladasTotales: 96,
    organismosFrecuentes: [
      { nombre: "Hospital Clínico San Borja", adjudicadas: 7 },
      { nombre: "Municipalidad de Las Condes", adjudicadas: 5 },
      { nombre: "Universidad de Chile", adjudicadas: 4 },
      { nombre: "JUNAEB", adjudicadas: 3 },
    ],
    categoriasExitosas: [
      { nombre: "Tecnología y Software", tasa: 0.48 },
      { nombre: "Consultoría", tasa: 0.36 },
      { nombre: "Servicios Profesionales", tasa: 0.29 },
    ],
    tasaAdjudicacion: 0.354,
    adjudicacionesPorConfirmar: [],
  },
};
